export default "__VITE_ASSET__D_S$aduH__"